import {
  getDispute as publicGetDispute,
  queryDisputes as publicQueryDisputes,
  typedQueryDisputes as publicTypedQueryDisputes,
  acceptDispute as publicAcceptDispute,
  defendDispute as publicDefendDispute,
  bulkUpdateDisputeTags as publicBulkUpdateDisputeTags,
  bulkUpdateDisputeTagsByFilter as publicBulkUpdateDisputeTagsByFilter,
} from './payments-disputes-v1-dispute-disputes.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DisputeQuery,
  DisputesQueryBuilder,
  typedQueryDisputes as universalTypedQueryDisputes,
} from './payments-disputes-v1-dispute-disputes.universal.js';
import { onDisputeCreated as publicOnDisputeCreated } from './payments-disputes-v1-dispute-disputes.public.js';
import { onDisputeUpdated as publicOnDisputeUpdated } from './payments-disputes-v1-dispute-disputes.public.js';

function customQueryDisputes(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryDisputes(httpClient)(),
    typedQueryFunction: (query: DisputeQuery) =>
      publicTypedQueryDisputes(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): DisputesQueryBuilder;
  function overloadedQuery(
    query: DisputeQuery
  ): ReturnType<typeof universalTypedQueryDisputes>;
  function overloadedQuery(query?: DisputeQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getDispute: MaybeContext<
  BuildRESTFunction<typeof publicGetDispute> & typeof publicGetDispute
> = /*#__PURE__*/ createRESTModule(publicGetDispute);
export const acceptDispute: MaybeContext<
  BuildRESTFunction<typeof publicAcceptDispute> & typeof publicAcceptDispute
> = /*#__PURE__*/ createRESTModule(publicAcceptDispute);
export const defendDispute: MaybeContext<
  BuildRESTFunction<typeof publicDefendDispute> & typeof publicDefendDispute
> = /*#__PURE__*/ createRESTModule(publicDefendDispute);
export const bulkUpdateDisputeTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDisputeTags> &
    typeof publicBulkUpdateDisputeTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateDisputeTags);
export const bulkUpdateDisputeTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDisputeTagsByFilter> &
    typeof publicBulkUpdateDisputeTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateDisputeTagsByFilter);
export const queryDisputes: MaybeContext<
  BuildRESTFunction<typeof customQueryDisputes> & typeof customQueryDisputes
> = /*#__PURE__*/ createRESTModule(customQueryDisputes);
/**
 * Triggered when a dispute is created.
 */
export const onDisputeCreated: BuildEventDefinition<
  typeof publicOnDisputeCreated
> &
  typeof publicOnDisputeCreated = createEventModule(publicOnDisputeCreated);
/**
 * Triggered when a dispute is updated.
 */
export const onDisputeUpdated: BuildEventDefinition<
  typeof publicOnDisputeUpdated
> &
  typeof publicOnDisputeUpdated = createEventModule(publicOnDisputeUpdated);

export {
  DisputeStage,
  DisputeReason,
  DisputeStatus,
  SellerProtection,
  DisputeChannel,
  DisputeActionType,
  SortOrder,
  WebhookIdentityType,
} from './payments-disputes-v1-dispute-disputes.universal.js';
export {
  Dispute,
  DisputeAction,
  ExtendedFields,
  Tags,
  TagList,
  TagsModified,
  GetDisputeRequest,
  GetDisputeResponse,
  QueryDisputesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryDisputesResponse,
  CursorPagingMetadata,
  Cursors,
  AcceptDisputeRequest,
  AcceptDisputeResponse,
  DefendDisputeRequest,
  DefendDisputeResponse,
  BulkUpdateDisputeTagsRequest,
  BulkUpdateDisputeTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateDisputeTagsResult,
  BulkActionMetadata,
  BulkUpdateDisputeTagsByFilterRequest,
  BulkUpdateDisputeTagsByFilterResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  DisputeCreatedEnvelope,
  DisputeUpdatedEnvelope,
  DisputesQueryResult,
  DisputesQueryBuilder,
  DisputeQuerySpec,
  BulkUpdateDisputeTagsOptions,
  BulkUpdateDisputeTagsByFilterOptions,
} from './payments-disputes-v1-dispute-disputes.universal.js';
export { utils } from './payments-disputes-v1-dispute-disputes.universal.js';
export {
  DisputeStageWithLiterals,
  DisputeReasonWithLiterals,
  DisputeStatusWithLiterals,
  SellerProtectionWithLiterals,
  DisputeChannelWithLiterals,
  DisputeActionTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateDisputeTagsApplicationErrors,
  BulkUpdateDisputeTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  DisputeQuery,
} from './payments-disputes-v1-dispute-disputes.universal.js';
